 /*
 Create By Sittikron : 20/06/2023
 Update By Sittikron : 09/08/2023  - เพิ่ม Permissionในการตรวจสอบ
 Update By Poom      : 24/10/2023  - เพิ่ม สิทธิ Service_Info
 Update By POOM : 26/01/2024  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
 Update By POOM : 2024-05-10  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที
 
*/
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation , useNavigate } from "react-router-dom";
import { Class_ETC_Decrypt 
  , Class_ETC_Encrypt
  , Class_ETC_MsgError
  , Class_ETC_MsgSuccess
  , Class_ETC_MsgErrorfocusByID
  , Class_ETC_SessionTimeOut
} from "../Class/Class_Etc";
import Pathurl from "../Class/Pathurl.json";
import { CP_CheckPermission } from "../Class/Class_Permission"
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import ConfigETC from "../Class/ConfigETC.json";
import MsgDescription from "../Class/MsgDescription.json";

function M_permission_ae() {

//#region ###################  Declare a variable   ###################
  
  const isService_department = CP_CheckPermission("service_list",["department"],false,false);
  const [pgAct, setPgAct] = useState("");
  const [pgper_id, setPgper_id] = useState(-1);
  const location = useLocation();
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [isPermissionStatus, setIsPermissionStatus] = useState(true);
  const [ ActEdit ] = useState(Class_ETC_Encrypt("Edit"));
  const [isPerMenu, setIsPerMenu] = useState(false);
  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);
  const navigate = useNavigate();

  // ประกาศตัวแปล Check Box
  const [isCheckPerMmain, setCheckPerMmain] = useState({

    Cb_my_timesheets_view: false,
    Cb_approve_view: false,
    Cb_clearing_view: false,
    Cb_timesheet_costs_view: false,

    Cb_projects_view: false,
    Cb_projects_add: false,
    Cb_projects_edit: false,
    Cb_projects_delete: false,

    Cb_projects_view_all: false,
    Cb_projects_overview: false,

  });
  // ประกาศตัวแปล Check Box
  const [isCheckPerMmaster, setCheckPerMmaster] = useState({
    Cb_department_view: false,
    Cb_department_add: false,
    Cb_department_edit: false,
    Cb_department_delete: false,

    Cb_position_view: false,
    Cb_position_add: false,
    Cb_position_edit: false,
    Cb_position_delete: false,

    Cb_staff_view: false,
    Cb_staff_add: false,
    Cb_staff_edit: false,
    Cb_staff_delete: false,

    Cb_customers_view: false,
    Cb_customers_add: false,
    Cb_customers_edit: false,
    Cb_customers_delete: false,

    Cb_task_view: false,
    Cb_task_add: false,
    Cb_task_edit: false,
    Cb_task_delete: false,

    Cb_time_off_view: false,
    Cb_time_off_add: false,
    Cb_time_off_edit: false,
    Cb_time_off_delete: false,

    Cb_holiday_view: false,
    Cb_holiday_add: false,
    Cb_holiday_edit: false,
    Cb_holiday_delete: false,

    Cb_configuration_view: false,
    Cb_configuration_edit: false,

    Cb_permission_group_view: false,
    Cb_permission_group_add: false,
    Cb_permission_group_edit: false,
    Cb_permission_group_delete: false,

    Cb_service_info_view : false,

  });
  // ประกาศตัวแปล Check Box
  const [isCheckPerMreport, setCheckPerMreport] = useState({

    Cb_report_project_view: false,
    Cb_report_staffs_view: false,
    Cb_report_tasks_view: false,
    Cb_report_position_view: false,
    Cb_report_transaction_view: false,
    Cb_report_timesheetbyperiod_view: false,
    Cb_report_timesheetbystaff_view: false,

    
  });

//#endregion
  
//#region ###################  ตัวเก็บค่า CheckBox     ###################

  const handleCheckPerMmainChange = (event) => {
    const { id, checked } = event.target;
    setCheckPerMmain((prevValues) => ({
      ...prevValues,
      [id]: checked,
    }));
  };

  const handleCheckPerMreportChange = (event) => {
    const { id, checked } = event.target;
    setCheckPerMreport((prevValues) => ({
      ...prevValues,
      [id]: checked,
    }));
  };

  const handleCheckPerMmasterChange = (event) => {
    const { id, checked } = event.target;
    setCheckPerMmaster((prevValues) => ({
      ...prevValues,
      [id]: checked,
    }));
  }; 

//#endregion

//#region ###################  open on loead        ###################

  useEffect(() => {
    if (isFirst === true) {
      GetParameter(function() {
        if (pgAct !== ""){   
          let isPerView = CP_CheckPermission("master" , ["permission_group_view"] , false , true);
          if (isPerView)
          {
            let isPerAdd = false; 
            let isPerEdit = false;

            if(pgAct === "Add" )
            {
              isPerAdd = CP_CheckPermission("master" , ["permission_group_add"] , false , true);
              setIsPermissionAdd(isPerAdd);
            }
            else
            {
              isPerEdit = CP_CheckPermission("master" , ["permission_group_edit"] , false , false);
              setIsPermissionEdit(isPerEdit);
            }
            GetConfig();
            if (isLoadedConfigData === true) {
                  if (pgAct === "Add") {
                    setIsLoadProgress(false);
                  } else {
                    Bind_Permission_Data("all",function() {
                      setIsPerMenu(true);
                      setIsLoadProgress(false);
                    });
                  }
                  setIsFirst(false);
            }
          };
        }
      });
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData , pgAct]);

  function GetParameter(_callback) {
    let isNullParameter = false;
    let per_id = "";
    let act = "";

    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        per_id = Class_ETC_Decrypt(location.state?.per_id.toString());
        act = Class_ETC_Decrypt(location.state?.act.toString());

        if (act === "") {
          isNullParameter = true;
        } else if (act !== "Add" && act !== "Edit") {
          isNullParameter = true;
        } else {
          if (act === "Edit" && per_id === "") {
            isNullParameter = true;
          }
        }
      }
    } catch {
      isNullParameter = true;
    }
    if (isNullParameter) {
      window.location.replace("../" + Pathurl.m_permission);
      if (_callback != null) {
          _callback();
      }
    } else {
      setPgAct(act);
      setPgper_id(per_id);
      if (_callback != null) {
          _callback();
      }
    }
  }

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  //#endregion

//#region ###################  Bind Data            ###################


  async function Bind_Permission_Data(isAct ,_callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        per_group_id: pgper_id.toString(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Permission_Getdata",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          // Bind ทั้ง 2 table ใช้ในกรณีเข้ามาครั้งแรก และ กด Cancel ของ Edit
          if (isAct === "all") {

            document.getElementById("txt_Permission_name").value = json.per_group_name;
            document.getElementById("txt_Permission_desc").value = json.per_group_desc;
            setIsPermissionStatus(json.per_group_status === 1 ? true : false);

            const permenumain = json.per_menu_main.split(",");  // ประกาศตัวแปรมารับค่าจาก Backend
            const bindCheckboxmain = {}; // ประกาศตัวแปร Array 
            permenumain.forEach((item) => { // ประกาศ Loop 
              const checkboxID = `Cb_${item}`; // ประกาศ Loop ต่อ String เอา Cb_ มาต่อทุกตัว
              bindCheckboxmain[checkboxID] = true; // ประกาศค่าที่ได้มาทั้งหมด ตาม ID ให้เป็น True 
            });
            setCheckPerMmain((prevState) => {
              const updatedStateMain = { ...prevState };           
              Object.keys(bindCheckboxmain).forEach((key) => {
                if (updatedStateMain.hasOwnProperty(key)) {
                  updatedStateMain[key] = bindCheckboxmain[key];
                }
              });      
              return updatedStateMain;
            });

            // master Checkbox
            const permenumaster = json.per_menu_master.split(",");
            const bindCheckboxmaster = {};
            permenumaster.forEach((item) => {
              const checkboxID = `Cb_${item}`;
              bindCheckboxmaster[checkboxID] = true;
            });       
            setCheckPerMmaster((prevState) => {
              const updatedStateMaster = { ...prevState };           
              Object.keys(bindCheckboxmaster).forEach((key) => {
                if (updatedStateMaster.hasOwnProperty(key)) {
                  updatedStateMaster[key] = bindCheckboxmaster[key];
                }
              });      
              return updatedStateMaster;
            });

            //report checkbox
            const permenureport = json.per_menu_report.split(",");  
            const bindCheckboxreport = {};
            permenureport.forEach((item) => {
              const checkboxID = `Cb_${item}`;
              bindCheckboxreport[checkboxID] = true;
            });
            setCheckPerMreport((prevState) => {
              const updatedStateReport = { ...prevState };           
              Object.keys(bindCheckboxreport).forEach((key) => {
                if (updatedStateReport.hasOwnProperty(key)) {
                  updatedStateReport[key] = bindCheckboxreport[key];
                }
              });      
              return updatedStateReport;
            });
            
            if (_callback != null) {
              _callback();
          }
          }
          // Bind table ข้างบน หลังงจาก กด Save ของ table ข้างบน
          else if (isAct === "Permission_detail") {
            document.getElementById("txt_Permission_name").value = json.per_group_name;
            document.getElementById("txt_Permission_desc").value = json.per_group_desc;
            setIsPermissionStatus(json.per_group_status === 1 ? true : false);
            if (_callback != null) {
              _callback();
          }
          }
          // Bind table ข้างล่าง หลังงจาก กด Save ของ table ข้างล่าง
          else{
            // Main Checkbox
            const permenumain = json.per_menu_main.split(",");  // ประกาศตัวแปรมารับค่าจาก Backend
            const bindCheckboxmain = {}; // ประกาศตัวแปร Array 
            permenumain.forEach((item) => { // ประกาศ Loop 
              const checkboxID = `Cb_${item}`; // ประกาศ Loop ต่อ String เอา Cb_ มาต่อทุกตัว
              bindCheckboxmain[checkboxID] = true; // ประกาศค่าที่ได้มาทั้งหมด ตาม ID ให้เป็น True 
            });
            setCheckPerMmain((prevState) => ({
              ...prevState,
              ...bindCheckboxmain, // Set ค่ประกาศที่ได้ ตาม ID ที่ต้องกันให้เป็น True เพื่อ Check box เป็น Check
            }));
            // master Checkbox
            const permenumaster = json.per_menu_master.split(",");
            const bindCheckboxmaster = {};
            permenumaster.forEach((item) => {
              const checkboxID = `Cb_${item}`;
              bindCheckboxmaster[checkboxID] = true;
            });
            setCheckPerMmaster((prevState) => ({
              ...prevState,
              ...bindCheckboxmaster,
            }));
            //report checkbox
            const permenureport = json.per_menu_report.split(",");  
            const bindCheckboxreport = {};
            permenureport.forEach((item) => {
              const checkboxID = `Cb_${item}`;
              bindCheckboxreport[checkboxID] = true;
            });
            setCheckPerMreport((prevState) => ({
              ...prevState,
              ...bindCheckboxreport,
            }));
          }       
          if (_callback != null) {
              _callback();
          }
        } else {
          window.location.replace("../" + Pathurl.m_permission);
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
    } catch {
      window.location.replace("../" + Pathurl.m_permission);
    }
  }

//#endregion

//#region ###################  Save  Permission detail table (tableบน)   ###################

  function onclickSavePermission(){

    setIsLoadProgress(true);

    var istxtError = "";
    var isError = "";

    if (document.getElementById("txt_Permission_name").value.trim() === "")
    {
      istxtError = "txt_Permission_name";
    }
    if (istxtError !== "") {
      isError = "Empty";
    }
    if (isError !== "") 
    {
      setIsLoadProgress(false);
      Class_ETC_MsgErrorfocusByID( MsgDescription.ERR001, istxtError);
    }
    else if (pgAct ==="Add")
    {
      SavedPermission();
    }
    else if (pgAct ==="Edit")
    {
       SavedPermission();
    }
  }

  async function SavedPermission()
  {

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      
      let pn = document.getElementById("txt_Permission_name").value.trim();
      let tpd = document.getElementById("txt_Permission_desc").value.trim();
      let ps = (isPermissionStatus === true ? "1" : "0");

      var raw;   

      if (pgAct === "Add")
      {
        raw = JSON.stringify({
          "per_group_name": pn,
          "per_group_desc": tpd,
          "per_group_status": ps,
        });
      }
      else
      {
        raw = JSON.stringify({
          "per_group_id": pgper_id,
          "per_group_name": pn,
          "per_group_desc": tpd,
          "per_group_status": ps,
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + (pgAct === "Add" ? "Permission_Add" : "Permission_Edit"),
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {

        if (pgAct === "Add"){
          setIsLoadProgress(false);
          document.getElementById("hd_Per_id").value = json.return_Per_group_id.toString();
          Class_ETC_MsgSuccess(MsgDescription.CFM001, Before_save_add);
        }
        else {
          Bind_Permission_Data("Permission_detail",function() {
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM001, null)
          });
        }

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
        
        
    };
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }

  }

 //#endregion

//#region ###################  after save add Permission detail             ###################

  function Before_save_add(){
    navigate( "../" + Pathurl.m_permission_ae, { state: {
      per_id:  Class_ETC_Encrypt(document.getElementById("hd_Per_id").value.trim()),act: ActEdit
      }}); 
    window.location.reload()
  }

//#endregion

//#region ###################  Save  Permission Menu table (tableล่าง)   ###################

  function SavedPermissionCheck(){

    setIsLoadProgress(true);  

    const checkedPermissionmain = Object.entries(isCheckPerMmain)
      .filter(([, checked]) => checked)
      .map(([id]) => id.replace("Cb_", ""));

    const checkedPermissionreport = Object.entries(isCheckPerMreport)
      .filter(([, checked]) => checked)
      .map(([id]) => id.replace("Cb_", ""));

    const checkedPermissionmaster = Object.entries(isCheckPerMmaster)
      .filter(([, checked]) => checked)
      .map(([id]) => id.replace("Cb_", ""));
  
    const per_menu_main = checkedPermissionmain.join(",");
    const per_menu_report = checkedPermissionreport.join(",");
    const per_menu_master = checkedPermissionmaster.join(",");

    SavedPermissionMenuEdit(per_menu_main , per_menu_report , per_menu_master);
  };

  async function SavedPermissionMenuEdit(per_menu_main , per_menu_report ,per_menu_master){

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        per_group_id: pgper_id.toString(),
        per_menu_main: per_menu_main,
        per_menu_master: per_menu_master,
        per_menu_report: per_menu_report
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Permission_Editmenu",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {

        Class_ETC_MsgSuccess(MsgDescription.CFM001, null);
        Bind_Permission_Data("Permission_checkbox",function() {
          setIsLoadProgress(false);
        });
        
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {

        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);

      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }      
  }

//#endregion

//#region ###################  Cancel btton          ###################

  function onclickCancel(){
    setIsLoadProgress(true);
    if (pgAct === "Add")
      {       
          document.getElementById("txt_Permission_name").value = "";
          document.getElementById("txt_Permission_desc").value = "";
          setIsPermissionStatus(true)
          setIsLoadProgress(false);
      }
    else
     {
        
      const clearCheckboxes = {};
      // Set all checkbox values to false
      Object.keys(isCheckPerMreport).forEach((key) => {
        clearCheckboxes[key] = false;     
      });
      setCheckPerMreport(clearCheckboxes);

      Object.keys(isCheckPerMmain).forEach((key) => {
        clearCheckboxes[key] = false;     
      });
      setCheckPerMmain(clearCheckboxes);

      Object.keys(isCheckPerMmaster).forEach((key) => {
        clearCheckboxes[key] = false;     
      });
      setCheckPerMmaster(clearCheckboxes);


      Bind_Permission_Data("all",function() {
        setIsLoadProgress(false);
      });
     }  
  }

//#endregion

  return (
    <>
    {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <Helmet>
        <title>Permission</title>
      </Helmet>

      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <h1 className="display-5">
                  {" "}
                  <i className="fas fa-lock" /> Permission group
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                {/* SELECT2 EXAMPLE */}
                {/* SELECT2 EXAMPLE */}
                <div className="card  shadow">
                  <div className="card-header">
                    <h3 className="card-title">{pgAct} Permission detail</h3>
                  </div>
                  <div className="card-body">
                    <div className="form-horizontal">
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Permission name<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Permission Name"
                            id="txt_Permission_name"
                          />
                          <input type="hidden" id="hd_Per_id" ></input>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Desc{" "}
                        </label>
                        <div className="col-sm-5">
                          <textarea
                            className="form-control"
                            rows={2}
                            placeholder="Desc ..."
                            id="txt_Permission_desc"
                          />
                        </div>
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Status{" "}
                        </label>
                        <div className="col-sm-3">
                          <BootstrapSwitchButton
                            onChange={(checked) => { setIsPermissionStatus(checked) }}
                            checked={isPermissionStatus}
                            width={ConfigETC.SwitchButton_in_active_width} 
                            onlabel={ConfigETC.SwitchButton_active_text}
                            onstyle={ConfigETC.SwitchButton_active_color}
                            offlabel={ConfigETC.SwitchButton_inactive_text}
                            offstyle={ConfigETC.SwitchButton_inactive_color}
                            size="xs"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer margin">
                    <button 
                       className="btn btn-default"
                       onClick={() => onclickCancel()}
                     >
                      <i className="fa  fa-times" /> cancel
                    </button>
                    {(isPermissionAdd || isPermissionEdit) &&
                      <button 
                        className="btn btn-primary float-right"
                        onClick={() => onclickSavePermission()}
                      >
                        <i className="fa  fa-save" /> Save
                      </button>
                    }
                  </div>
                  {/* end loading */}
                </div>
              </div>
            </div>

            {isPerMenu && (
              <>
            <div className="card card-outline shadow">
              <div className="card-header">
                <h3 className="card-title">
                <i className="far fa-list-alt"></i> Permission Menu
                </h3>
              </div>
              {/* /.card-header */}

              <div className="card-body table-responsive p-0 " >
 

                <table className="table table-head-fixed  table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: "40%" }}>Menu</th>
                      <th style={{ width: "15%" }} className="text-center">
                        View
                      </th>
                      <th style={{ width: "15%" }} className="text-center">
                        Add
                      </th>
                      <th style={{ width: "15%" }} className="text-center">
                        Edit
                      </th>
                      <th style={{ width: "15%" }} className="text-center">
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="text-sm margin-right">
                          <b>
                            {" "}
                            <i className="nav-icon fas fa-table" /> My Timesheets
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="Cb_my_timesheets_view"
                        checked={isCheckPerMmain.Cb_my_timesheets_view}
                        onChange={handleCheckPerMmainChange}
                      />
                    </td>
                    <td className="text-center">
                      
                    </td>
                    <td className="text-center">
                      
                    </td>
                    <td className="text-center">
                      
                    </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i className="av-icon fas fa-chalkboard-teacher" /> Approve
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox"
                          id="Cb_approve_view"
                          checked={isCheckPerMmain.Cb_approve_view}
                          onChange={handleCheckPerMmainChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i className="nav-icon fas fa-check-double" />  Clearing
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_clearing_view"
                          checked={isCheckPerMmain.Cb_clearing_view}
                          onChange={handleCheckPerMmainChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right">
                         <b>
                            {" "}
                            <i className="fab fa-btc" /> Timesheet Costs <span className="text-muted">(Work time,Over time)</span>
                            </b>
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_timesheet_costs_view"
                          checked={isCheckPerMmain.Cb_timesheet_costs_view}
                          onChange={handleCheckPerMmainChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i className="nav-icon far fa-building" /> Projects
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_projects_view"
                          checked={isCheckPerMmain.Cb_projects_view}
                          onChange={handleCheckPerMmainChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_projects_add"
                          checked={isCheckPerMmain.Cb_projects_add}
                          onChange={handleCheckPerMmainChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_projects_edit"
                          checked={isCheckPerMmain.Cb_projects_edit}
                          onChange={handleCheckPerMmainChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_projects_delete"
                          checked={isCheckPerMmain.Cb_projects_delete}
                          onChange={handleCheckPerMmainChange}
                        />
                      </td>
                    </tr>  
                    <tr>
                      <td>
                        <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" /> Project View all 
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_projects_view_all"
                          checked={isCheckPerMmain.Cb_projects_view_all}
                          onChange={handleCheckPerMmainChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" />  Projects Overview
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_projects_overview"
                          checked={isCheckPerMmain.Cb_projects_overview}
                          onChange={handleCheckPerMmainChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                  

                    <tr>
                      <td>
                      <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i className="nav-icon fas fa-chart-bar" /> Report
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right pl-4">
                         
                            {" "}
                            <i className="far fa-dot-circle" />  Project report 
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_report_project_view"
                          checked={isCheckPerMreport.Cb_report_project_view}
                          onChange={handleCheckPerMreportChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" />  Staffs report 
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_report_staffs_view"
                          checked={isCheckPerMreport.Cb_report_staffs_view}
                          onChange={handleCheckPerMreportChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" />  Tasks report 
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_report_tasks_view"
                          checked={isCheckPerMreport.Cb_report_tasks_view}
                          onChange={handleCheckPerMreportChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right pl-4">
                         
                            {" "}
                            <i className="far fa-dot-circle" />  Position report 
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_report_position_view"
                          checked={isCheckPerMreport.Cb_report_position_view}
                          onChange={handleCheckPerMreportChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" />  Transaction report 
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_report_transaction_view"
                          checked={isCheckPerMreport.Cb_report_transaction_view}
                          onChange={handleCheckPerMreportChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" />  Timesheet By Period report
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_report_timesheetbyperiod_view"
                          checked={isCheckPerMreport.Cb_report_timesheetbyperiod_view}
                          onChange={handleCheckPerMreportChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>

                    
                    <tr>
                      <td>
                        <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" />  Timesheet By Staff report
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_report_timesheetbystaff_view"
                          checked={isCheckPerMreport.Cb_report_timesheetbystaff_view}
                          onChange={handleCheckPerMreportChange}
                        />
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>



                    <tr className="bg-light">
                      <td>
                      <div className="text-sm margin-right ">
                          <b>
                            {" "}
                             BACKEND
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>

                    <tr>
                      <td>
                      <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i className="nav-icon far fa-user-circle" /> Customers
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_customers_view"
                          checked={isCheckPerMmaster.Cb_customers_view}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_customers_add"
                          checked={isCheckPerMmaster.Cb_customers_add}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_customers_edit"
                          checked={isCheckPerMmaster.Cb_customers_edit}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_customers_delete"
                          checked={isCheckPerMmaster.Cb_customers_delete}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                      <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i className="nav-icon fa fa-users" /> Staff
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_staff_view"
                          checked={isCheckPerMmaster.Cb_staff_view}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_staff_add"
                          checked={isCheckPerMmaster.Cb_staff_add}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_staff_edit"
                          checked={isCheckPerMmaster.Cb_staff_edit}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_staff_delete"
                          checked={isCheckPerMmaster.Cb_staff_delete}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                      <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i className="fas fa-cogs" /> SETTING
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                        
                      </td>
                      <td className="text-center">
                       
                      </td>
                      <td className="text-center">
                        
                      </td>
                    </tr>

                    {isService_department === true && 
                      <>
                        <tr>
                          <td>
                          <div className="text-sm margin-right pl-4">
                              
                                {" "}
                                <i className="far fa-dot-circle" /> Department
                            
                            </div>
                          </td>
                          <td className="text-center">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="Cb_department_view"
                              checked={isCheckPerMmaster.Cb_department_view}
                              onChange={handleCheckPerMmasterChange}
                            />
                          </td>
                          <td className="text-center">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="Cb_department_add"
                              checked={isCheckPerMmaster.Cb_department_add}
                              onChange={handleCheckPerMmasterChange}
                            />
                          </td>
                          <td className="text-center">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="Cb_department_edit"
                              checked={isCheckPerMmaster.Cb_department_edit}
                              onChange={handleCheckPerMmasterChange}
                            />
                          </td>
                          <td className="text-center">
                            <input 
                              className="form-check-input" 
                              type="checkbox" 
                              id="Cb_department_delete"
                              checked={isCheckPerMmaster.Cb_department_delete}
                              onChange={handleCheckPerMmasterChange}
                            />
                          </td>
                        </tr>
                      </>
                    }



                    <tr>
                      <td>
                      <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" /> Position
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_position_view"
                          checked={isCheckPerMmaster.Cb_position_view}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_position_add"
                          checked={isCheckPerMmaster.Cb_position_add}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_position_edit"
                          checked={isCheckPerMmaster.Cb_position_edit}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_position_delete"
                          checked={isCheckPerMmaster.Cb_position_delete}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                    </tr>
                    
                   
                    <tr>
                      <td>
                      <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" /> Task
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_task_view"
                          checked={isCheckPerMmaster.Cb_task_view}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_task_add"
                          checked={isCheckPerMmaster.Cb_task_add}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_task_edit"
                          checked={isCheckPerMmaster.Cb_task_edit}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_task_delete"
                          checked={isCheckPerMmaster.Cb_task_delete}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                      <div className="text-sm margin-right pl-4">
                          
                            {" "}
                            <i className="far fa-dot-circle" /> Time off
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_time_off_view"
                          checked={isCheckPerMmaster.Cb_time_off_view}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_time_off_add"
                          checked={isCheckPerMmaster.Cb_time_off_add}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_time_off_edit"
                          checked={isCheckPerMmaster.Cb_time_off_edit}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_time_off_delete"
                          checked={isCheckPerMmaster.Cb_time_off_delete}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                      <div className="text-sm margin-right pl-4">
                         
                            {" "}
                            <i className="far fa-dot-circle" /> Holiday
                          
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_holiday_view"
                          checked={isCheckPerMmaster.Cb_holiday_view}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_holiday_add"
                          checked={isCheckPerMmaster.Cb_holiday_add}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_holiday_edit"
                          checked={isCheckPerMmaster.Cb_holiday_edit}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_holiday_delete"
                          checked={isCheckPerMmaster.Cb_holiday_delete}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                      <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i className="fas fa-wrench" /> Company Setting
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_configuration_view"
                          checked={isCheckPerMmaster.Cb_configuration_view}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        {/* เว้นที่ให้ CSS */}
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_configuration_edit"
                          checked={isCheckPerMmaster.Cb_configuration_edit}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        {/* เว้นที่ให้ CSS */}
                      </td>
                    </tr>
                    <tr>
                      <td>
                      <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i className="nav-icon fas fa-lock" /> Permission Group
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_permission_group_view"
                          checked={isCheckPerMmaster.Cb_permission_group_view}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_permission_group_add"
                          checked={isCheckPerMmaster.Cb_permission_group_add}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_permission_group_edit"
                          checked={isCheckPerMmaster.Cb_permission_group_edit}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_permission_group_delete"
                          checked={isCheckPerMmaster.Cb_permission_group_delete}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                      <div className="text-sm margin-right ">
                          <b>
                            {" "}
                            <i class="fas fa-info-circle"></i> Service Info
                          </b>
                        </div>
                      </td>
                      <td className="text-center">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="Cb_service_info_view"
                          checked={isCheckPerMmaster.Cb_service_info_view}
                          onChange={handleCheckPerMmasterChange}
                        />
                      </td>
                      <td className="text-center"></td>
                      <td className="text-center"></td>
                      <td className="text-center"></td>
                    </tr>



                  </tbody>
                </table>

              </div>
{/* <br/><br/><br/> */}

              {/* /.card-body */}
              {(isPermissionAdd || isPermissionEdit) &&
                <div className="card-footer margin">
                  <button
                    className="btn btn-primary float-right"  
                    onClick={() => SavedPermissionCheck()}             
                  >
                    <i className="fa  fa-save" /> Save Permission
                  </button>
                </div>
              }
            </div>
            </>
            )}
            {/* /.card */}
            {/* /.row (main row) */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default M_permission_ae;
